import axios from 'axios';
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import Demand from '../../../../Models/MMontantBloquer';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import Tab1 from './Tab1';
import SearInputG from "../../../SearchInput"
import Data from '../../../../Data/Data.json'
import { Radio } from 'antd';


//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMHCQ";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import RadioBox from "../../../Radiox";


const ValidCheque = () => {
    // usestate pour remplir le tableau
    const [donnees, setData] = useState<DataType[]>([]);
    const [state, setstate] = useState(false)
    const [Lim, setlim] = useState('aba')

    const Getselectcli = (value: any) => {
        setlim(form.getFieldValue("NUMCLI"))
        form.setFieldValue("NBCHQR", 1);
        consultComptes()

    }


    function HandleAnnul() {
        setSelectedRowKeys([]);
        setData([])
        //setAjout(false);
        //setConsult(false);
        //setModif(true);
        //setEnreg(true);
        //setActual(true);
        //setAnnul(true);
        setAjoutActif(false);
        form.resetFields();
        setSbmit('');
        //setRadioaCheck(false)
        //setradio(false);
        localStorage.setItem(Data.LocalVariable.reset, "1")
        localStorage.setItem(Data.LocalVariable.Mainreset, "1")
        localStorage.clear();
    }

    //    let searchCompte: ParamsPicklist = { CodeAgence: Lim, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'NUMCLI', Choix: 22 }
    let searchCompte: ParamsPicklist = { CodeAgence: Lim, Table: "HCQ", Colonne1: "NUMCPT", Colonne2: "NUMDEMANDE", Colagence: 'NUMCPT', Choix: 22 }

    //column du tableau
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro chèque',
            dataIndex: 'NUMCHQ',
        },
        {
            title: 'Type de chèque',
            dataIndex: 'TYPCHQ',
        },
        {
            title: 'Status',
            dataIndex: 'CDETAT',
        },
        {
            title: 'Situation',
            dataIndex: 'STACHQ',
        },
        {
            title: 'Montant chèque',
            dataIndex: 'MTNCHQ',
        },
        {
            title: 'Agence',
            dataIndex: 'AGCCPT',
        },
        //STACHQ

    ];

    // USER SESSION
    const [form] = Form.useForm();
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [sbmit, setSbmit] = useState("")

    const authHeader = useAuthHeader()

    let searchDmandCHQ: ParamsPicklist = { CodeAgence: Perss.codage, Table: "DEMANDECHQ", Colonne1: "NUMDEMANDE", Colonne2: "NOMCPT", Colagence: 'codeage',colfiltre: "CDETAT", valfiltre: '01', Choix: 22 }

    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        //sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].REFMARQ))
        //consult();
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });
    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });
    }



    //function pour lire loadData

    // setTimeout(() => {
    //     if (donnees.length == 0) {
    //         if (!state) {
    //             setstate(true)
    //             //Consultableau()
    //         }
    //     }
    //     try {
    //         let reset = localStorage.getItem(Data.LocalVariable.reset)
    //         if (reset == "1") {
    //             setData([])
    //         }
    //     }
    //     catch (error) {
    //         console.log(error)
    //     }
    // }, 0.1);



    // Gestion des Items
    const items: TabsProps['items'] = [
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Validation chéquier
                </span>
            ),
            children: <Tab1 />, //form={form}
        },
    ];

    // CONSULT POUR RECUPERER LE COMPTE
    function consultComptes() {
        if (form.getFieldValue("NUMDEMANDE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de reference", icon: "warning" });

        } else {

            let data = Crypter.encrypt(form.getFieldValue("NUMDEMANDE"));
            let codeage = Crypter.encrypt(Perss.codage)

            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadDemandCHQ,
                    headers: {
                        'CypherREFMARQ': data,
                        'CypherCodeage': codeage,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));

                            if (res.Result == null) {
                                SweetAlert.fire({ title: "Warning", text: 'la Référence appartient a une agence distante', icon: "warning" });
                                HandleAnnul()
                            } else {

                                //console.log(JSON.stringify(res))
                                let DemandCHQ = res.Result.Table[0]
                                if (res.StatutCode == 200) {
                                    form.setFieldsValue(DemandCHQ);
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }



    // function consult tableableau
    function Consultableau() {

        if (form.getFieldValue("NUMCPT") == null) {
            SweetAlert.fire({ title: "", text: "Renseigner le numéro de compte", icon: "warning" })
        } else {
            // if (form.getFieldValue("Type") == null) {
            //     SweetAlert.fire({ title: "", text: "Renseigner le type de chéquier a valider", icon: "warning" })
            // } else {
            let a = form.getFieldValue("NUMCPT")
            let b = 'IM';
            let c = form.getFieldValue("Type");
            let d = Perss.codage;

            setLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AllreadHCQ,
                headers: {
                    'CypherNUMCPT': Crypter.encrypt(a),
                    'CypherETAT': Crypter.encrypt(b),
                    'CypherTYPE': Crypter.encrypt(c),
                    'Cyphercodeage': Crypter.encrypt(d),
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json',
                },
            };


            // MAPPING DANS LE TABLEAU
            let dat: DataType[] = [];
            axios.request(config)
                .then((response) => {
                    setLoading(false);

                    if (response.data) {
                        let datas = JSON.parse(JSON.stringify((response.data.Result)));
                        //console.log('response.data stan ' + (datas[1]));
                        if (datas[1] == null) {
                            //alert(1);
                            SweetAlert.fire({ text: "Il ne possède pas de chequier en attente de validation", icon: "warning" })
                        } else {
                            // alert(2);
                            // console.log('response.data stan ' + (datas));
                            sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(datas[1].NUMDEMANDE))
                        }

                        datas.map((val: any, key: any) => {
                            dat.push({
                                key: key,
                                NUMCHQ: val.NUMCHQ,
                                SERCHQ: val.SERCHQ,
                                DATPAI: val.DATPAI,
                                MTNCHQ: val.MTNCHQ,
                                TYPCHQ: val.TYPCHQ,
                                NUMRAP: val.NUMRAP,
                                STACHQ: val.STACHQ,
                                DATSAI: val.DATSAI,
                                datcre: val.datcre,
                                AGCCPT: val.AGCCPT,
                                NUMCPT: val.NUMCPT,
                                UTILIS: val.UTILIS,
                                CDETAT: val.CDETAT,
                                UTIVAL: val.UTIVAL,
                                NUMDEMANDE: val.NUMDEMANDE,
                                DATVAL: undefined,
                                NBCHQS: undefined,
                                NBCHQR: undefined,
                                trie: undefined
                            })
                        })
                        setData((dat))
                    } else {
                        SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                });
            //  }
        }

    }

    // function Onfinish
    const onFinish = (values: any) => {

        if (donnees.length > 0) {

            if (sbmit == 'valid') {
                let NUMDEMANDE = (((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "")
                //alert(NUMDEMANDE);
                let data2 = Crypter.encrypt(Perss.coduti)
                let data3 = Crypter.encrypt(Perss.datjour)
                let data4 = Crypter.encrypt(Perss.codage)
                let data5 = Crypter.encrypt('2')


                SweetAlert.fire({
                    title: "valider chéquier",
                    text: "Voulez-vous valider le chéquier " + (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "") + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidInvalidHCQ,
                            headers: {
                                'CypherRefmar': NUMDEMANDE,
                                'CypherUTIVAL': data2,
                                'CypherDATVAL': data3,
                                'Cyphercodeage': data4,
                                'Cyphertrie': data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    //console.log(res)
                                    let code = res.Result
                                    if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "le même user ne peut validé le chéquier", icon: "warning" })
                                    } else if (code == 'ErreurJr') {
                                        SweetAlert.fire({ title: " ", text: "la journée comptable", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "chéquier validé N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        setSelectedRowKeys([]);
                                        setData([])
                                    }

                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })
            } else if (sbmit == "invalid") {
                let NUMDEMANDE = (((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "")
                //alert(NUMDEMANDE);
                let data2 = Crypter.encrypt(Perss.coduti)
                let data3 = Crypter.encrypt(Perss.datjour)
                let data4 = Crypter.encrypt(Perss.codage)
                let data5 = Crypter.encrypt('3')


                SweetAlert.fire({
                    title: "invalider chéquier",
                    text: "Voulez-vous invalider le chéquier " + (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "") + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidInvalidHCQ,
                            headers: {
                                'CypherRefmar': NUMDEMANDE,
                                'CypherUTIVAL': data2,
                                'CypherDATVAL': data3,
                                'Cyphercodeage': data4,
                                'Cyphertrie': data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    let code = res.Result

                                    if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "le même user ne peut Invalidé le chéquier", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        setData([])
                                        SweetAlert.fire({ title: " ", text: "chéquier Invalidé N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        setSelectedRowKeys([]);
                                        setData([])
                                    }

                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })

            }

        } else {

        }

    }



    // control du forms
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Validation chèquier : {window.location.pathname.toUpperCase()}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultableau() }} type="ghost" block>
                                    Afficher
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { setSbmit('valid') }} type="ghost" htmlType="submit" block>
                                    valider
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { setSbmit('invalid') }} type="ghost" htmlType="submit" block>
                                    invalider
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { HandleAnnul() }} type="ghost" block  >
                                    Actualiser
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>

                            <div className='tabItem' >

                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border-left '>
                                            <legend> Validation d'un chéquier </legend>
                                            <Box style={{ display: 'flex' }} className='border' sx={{  mb: 2 }}>
                                                <Box style={{ marginTop: -5, width: '40%' }}>
                                                    <SearchModal Taille1={150}  Taille2={250}  disabled={false} Titre="" label="Réference" name="NUMDEMANDE" Parametre={searchDmandCHQ} ExecuteafterSelect1={Getselectcli}  form={form} />
                                                </Box>
                                                <Box style={{ marginTop: -5, width: '50%' }}>
                                                    <SearchModal Taille1={250}  Taille2={300}  disabled={true} Titre="" label="N° de compte" name="NUMCPT" Parametre={searchCompte}  form={form} />
                                                </Box>
                                            </Box>

                                            <Box fontStyle="inherit" className='border' sx={{  mb: 2,marginTop: 1 }}>

                                                <Spin spinning={loading}  >
                                                    <Table  dataSource={donnees} columns={columns} style={{ textAlign: "center", width: '100%' }} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                                </Spin>
                                            </Box>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default ValidCheque;